<template>
    <div id="searchPage">
        <div class="header">
            <span class="head-l"><img src="../assets/img/箭头 (3).png" alt="" @click="goback"></span>
            <div class="head-m"><input type="text" placeholder="搜索商品" v-model="value" @keyup.enter="search"><img src="../assets/img/搜索商品.png" alt="" @click="search"></div>
        </div>
        <div class="container" v-if="datainfo">
            <div class="content" v-for="(item,index) in goodsList" :key="index"  @click="goodsDetail(item.goods_id)">
                <div class="imgbox"><img :src="'http://youwei.jingmaie-co.cn/'+item.original_img" alt=""></div>
                <div class="textbox">
                    <div class="name">{{item.goods_name}}</div>
                    <div class="price">￥{{item.shop_price}}</div>
                    <div class="sales">
                        <span>{{item.store.store_name}}<img src="../assets/img/右箭头.png" alt=""> </span>
                        <span>销量{{item.sales_sum}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {searchGoods} from '@/api'
export default {
    data(){
        return{
            value:'', //用户输入的搜索内容
            goodsList:'', //搜索商品列表
            datainfo:false
        }
    },
    methods:{
        goback(){
            this.$router.go(-1)
        },
        async search(){
            let params = {
                q:this.value
            }
            let res = await searchGoods(params)
            if(res.status===1){
                this.datainfo = true
                this.goodsList = res.result
            }else{
                this.$toast({message:res.msg,duration:'2000'}) 
            }
        },
        goodsDetail(id){
            this.$router.push({ name: "goodsDetail", params: { id: id } });
        }
    }
}
</script>
<style lang="less" scoped>
#searchPage{
    width: 750px;
    height: 100vh;
    background-color: #F5F5F5;
    .header{
        width: 100%;
        height: 98px;
        background-color: #fff;
        position: relative;
        overflow: hidden;
        .head-l{
            display: inline-block;
            width: 40px;
            padding-top: 20px;
            position: absolute;
            top: 5px;
            left: 30px;
            img{
                width: 27px;
                height: 47px;
            }
        }
        .head-m{
            height: 50px;
            width: 500px;
            border: 2px solid #FE0D07;
            padding: 5px;
            margin: 0 auto;
            margin-top: 20px;
            border-radius: 50px;
            padding-left: 20px;
            position: relative;
            input{
                width: 80%;
                height: 40px;
                border: none;
            }
            img{
                position: absolute;
                right: 20px;
                top: 3px;
                width: 70px;
                height: 52px;

            }
        }
        
    }
    .container{
        margin-top: 20px;
        background-color: #fff;
        padding: 20px;
        .content{
            display: flex;
            margin: 20px;
            .imgbox{
                width: 120px;
                height: 120px;
                margin-right: 30px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .textbox{
                flex: 1;
                height: 130px;
                padding-bottom: 10px;
                border-bottom: 2px solid #dddddd;
                .name{
                    height: 70px;
                }
                .price{
                    color: #FE0D07;
                }
                .sales{
                    display: flex;
                    justify-content: space-between;
                    color: #686868;
                    img{
                        width: 10px;
                        height: 20px;
                        margin-left: 15px;
                    }
                }
            }
        }
    }
}
</style>